import { useMessage } from '@/context/Message';
import React, { PropsWithChildren, useEffect } from 'react';
import ContentLoader from '../ContentLoader';

interface AssetDownloadWrapperProps {
  download?: boolean;
  isDownloading?: boolean;
  error?: any;
  errorMessage?: any;
}

const AssetDownloadWrapper = ({
  download,
  children,
  isDownloading,
  error,
  errorMessage,
}: PropsWithChildren<AssetDownloadWrapperProps>) => {
  const message = useMessage();

  useEffect(() => {
    if (error) {
      message.error({ message: errorMessage });
    }
  }, [error, errorMessage, message]);

  if (!download) return <>{children}</>;

  return (
    <>
      {children}
      {isDownloading && <ContentLoader />}
    </>
  );
};

export default AssetDownloadWrapper;
